<div
  class="alert-card box no-border"
  style="width: 100%">
  @if (document()) {
    <div class="alert-info">
      <div class="icon-container">
        <topo-icon [props]="iconProps()" />
      </div>
      <div class="text-container">
        <header>
          <span class="alert-type-label">{{ headerLabel() }}</span>
          <span class="elapsed-time">{{ elapsedTime$ | async }}</span>
        </header>

        <section>{{ content() | stripHtml }}</section>
      </div>
    </div>
    @if (showImpactedAssets() && impactedAssetsDetails()) {
      @let details = impactedAssetsDetails();
      @let counts = details?.counts;

      <div
        class="impacted-assets-container"
        [ngClass]="details?.severityClass">
        <div class="search-distance">{{ details?.distance }}&nbsp;{{ details?.distanceUnit }}</div>
        <div class="impacted-asset-count">
          <topo-icon [props]="{ type: 'system', path: 'icon-account-profile', style: { fontSize: '1.5vh' } }" />
          <span>{{ counts?.people }}</span>
        </div>
        <div class="impacted-asset-count">
          <topo-icon [props]="{ type: 'system', path: 'icon-building', style: { fontSize: '1.5vh' } }" />
          <span>{{ counts?.facilities }}</span>
        </div>
        <div class="impacted-asset-count">
          <topo-icon [props]="{ type: 'system', path: 'icon-hierarchy', style: { fontSize: '1.5vh' } }" />
          <span>{{ counts?.other }}</span>
        </div>
      </div>
    }
  } @else {
    <div class="alert-info">
      <div class="icon-container">
        <div
          class="skeleton"
          style="height: 3vh; width: 3vh"></div>
      </div>
      <div class="text-container">
        <header>
          <div
            class="skeleton"
            style="height: 1.5vh; width: 40%"></div>
          <div style="width: 40%"></div>
          <div
            class="skeleton"
            style="height: 1.5vh; width: 20%"></div>
        </header>

        <section>
          <div
            class="skeleton"
            style="height: 2vh; width: 100%"></div>
          <div
            class="skeleton"
            style="height: 2vh; width: 100%"></div>
        </section>
      </div>
    </div>
  }
</div>
